import { AxiosInstance } from 'axios';

import { IParameter } from 'src/views/Admin/Parameters/types';
import { insertId } from '../../insertId';
import { toResponse } from '../../genericToResponse';
import { cancellable } from '../../cancellable';

export default (api: AxiosInstance, url: string) => (id?: number) => {
  const urlWithId = id ? insertId(url, id) : url;
  return cancellable<IParameter[]>(
    (cancelOptions: any) => api.get(urlWithId, cancelOptions),
    toResponse
  );
};



// WEBPACK FOOTER //
// ./src/services/api/admin/parameters/get.ts